import React, {useCallback} from 'react';
import {FormControl, InputLabel, Select, MenuItem} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {SelectChangeEvent} from '@mui/material';
import {FilterDocumentType} from '@/types/filter';

interface MyDocumentsFilterProps {
  filterType: FilterDocumentType;
  currentFilterValue: string;
  onFilterChange: (event: SelectChangeEvent<string>) => void;
}

const MyDocumentsFilter: React.FC<MyDocumentsFilterProps> = ({
  filterType,
  currentFilterValue,
  onFilterChange
}) => {
  const {t} = useTranslation();

  const getFilterLabel = useCallback(
    (value: string) => {
      switch (filterType) {
        case 'group':
          if (value === 'my') {
            return t('my_teams');
          }
          return t('my_all_groups');
        case 'event':
          if (value === 'my') {
            return t('my_events');
          } else if (value === 'all') {
            return t('eventType');
          }
          return t('my_past_events');
      }
    },
    [filterType, t]
  );

  return (
    <FormControl fullWidth>
      <InputLabel id="my-documents-label" shrink>
        {getFilterLabel('all')}
      </InputLabel>
      <Select
        labelId="my-documents-label"
        label={getFilterLabel('all')}
        value={currentFilterValue}
        onChange={onFilterChange}
      >
        <MenuItem value="all">
          {filterType === 'event' ? t('all_events') : t('all_groups')}
        </MenuItem>
        <MenuItem value="my">{getFilterLabel('my')}</MenuItem>
        {filterType === 'event' && (
          <MenuItem value="past">{getFilterLabel('past')}</MenuItem>
        )}
      </Select>
    </FormControl>
  );
};

export default MyDocumentsFilter;
